//获取滚动条当前的位置
function getScrollTop() {
    if(document.documentElement && document.documentElement.scrollTop) {
        return document.documentElement.scrollTop
    } else if (window.pageYOffset) {
        return window.pageYOffset
    } else if (document.body) {
        return document.body.scrollTop
    }
    return 0
}

//获取当前可视范围的高度
function getClientHeight () {
    return document.documentElement && document.documentElement.clientHeight ? document.documentElement.clientHeight : window.innerHeight
}

//获取文档完整的高度
function getScrollHeight () {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
}

export default {
    mounted () {
        window.addEventListener('scroll', this.checkPagePullUp)
    },
    destroyed () {
        window.removeEventListener('scroll', this.checkPagePullUp)
    },
    methods: {
        checkPagePullUp () {
            const scroll_to_bottom = getScrollTop() + getClientHeight() >= getScrollHeight() - 60
            if (scroll_to_bottom) {
                this.onPullUp()
            }
        }
    }
}